/* eslint-disable @typescript-eslint/naming-convention */
import account from './icons/account.svg?component';
import add from './icons/add.svg?component';
import add_box from './icons/add_box.svg?component';
import add_circle from './icons/add_circle.svg?component';
import add_document_snippet from './icons/add_document_snippet.svg?component';
import add_emoji from './icons/add_emoji.svg?component';
import add_image_snippet from './icons/add_image_snippet.svg?component';
import add_link_snippet from './icons/add_link_snippet.svg?component';
import add_note_snippet from './icons/add_note_snippet.svg?component';
import add_photo from './icons/add_photo.svg?component';
import add_text_snippet from './icons/add_text_snippet.svg?component';
import agenda from './icons/agenda.svg?component';
import ai_button from './icons/ai_button.svg?component';
import angle_down from './icons/angle_down.svg?component';
import angle_left from './icons/angle_left.svg?component';
import angle_right from './icons/angle_right.svg?component';
import angle_up from './icons/angle_up.svg?component';
import arrow_back from './icons/arrow_back.svg?component';
import arrow_drop_down from './icons/arrow_drop_down.svg?component';
import arrow_forward from './icons/arrow_forward.svg?component';
import arrow_outward from './icons/arrow_outward.svg?component';
import arrow_right from './icons/arrow_right.svg?component';
import arrow_up from './icons/arrow_up.svg?component';
import attach from './icons/attach.svg?component';

import audio_file from './icons/audio_file.svg?component';

import back from './icons/back.svg?component';

import calendar from './icons/calendar.svg?component';
import calendar_month from './icons/calendar_month.svg?component';
import change_font_size from './icons/change_font_size.svg?component';
import check from './icons/check.svg?component';
import check_circle from './icons/check_circle.svg?component';
import check_circle_fill from './icons/check_circle_fill.svg?component';
import checked_box from './icons/checked_box.svg?component';
import chevron_right from './icons/chevron_right.svg?component';
import circular_cancel from './icons/circular_cancel.svg?component';
import circular_info from './icons/circular_info.svg?component';
import classIcon from './icons/class.svg?component';
import close from './icons/close.svg?component';
import collaboration from './icons/collaboration.svg?component';
import content from './icons/content.svg?component';
import copy from './icons/copy.svg?component';
import courses from './icons/courses.svg?component';
import create_from_template from './icons/create_from_template.svg?component';
import cursor from './icons/cursor.svg?component';
import chat_history from './icons/chat_history.svg?component';

import dashboard from './icons/dashboard.svg?component';
import dnd from './icons/dnd.svg?component';
import doc_export from './icons/doc_export.svg';
import dots from './icons/dots.svg?component';
import download from './icons/download.svg?component';
import draft from './icons/draft.svg?component';
import drag_indicator from './icons/drag_indicator.svg?component';

import edit from './icons/edit.svg?component';
import editor_loading from './icons/editor_loading.svg?component';
import editor_saved from './icons/editor_saved.svg?component';
import editor_unsaved from './icons/editor_unsaved.svg?component';
import error from './icons/error.svg?component';
import error_circle from './icons/error_circle.svg?component';
import expand from './icons/expand.svg?component';
import export_icon from './icons/export_icon.svg?component';
import external_file from './icons/external_file.svg?component';
import external_folder from './icons/external_folder.svg?component';
import eye from './icons/eye.svg?component';
import eye_off from './icons/eye_off.svg?component';

import file_add from './icons/file_add.svg?component';
import filter from './icons/filter.svg?component';
import folder_open from './icons/folder_open.svg?component';
import format_color_reset from './icons/format_color_reset.svg?component';
import format_color_text from './icons/format_color_text.svg?component';
import fullscreen from './icons/fullscreen.svg?component';

import generic_file from './icons/generic_file.svg?component';
import go_to_end from './icons/go_to_end.svg?component';
import goal from './icons/goal.svg?component';

import help from './icons/help.svg?component';

import info_fill from './icons/info_fill.svg?component';
import info_outline from './icons/info_outline.svg?component';
import item_card_calendar_checked from './icons/item_card_calendar_checked.svg?component';
import item_card_calendar_month_tiny from './icons/item_card_calendar_month_tiny.svg?component';
import item_card_calendar_plus from './icons/item_card_calendar_plus.svg?component';
import item_card_one_snippet from './icons/item_card_one_snippet.svg?component';
import item_card_three_snippets from './icons/item_card_three_snippets.svg?component';
import item_card_timer from './icons/item_card_timer.svg?component';
import item_card_two_snippets from './icons/item_card_two_snippets.svg?component';
import item_card_visibility_off_tiny from './icons/item_card_visibility_off_tiny.svg?component';
import item_card_visibility_tiny from './icons/item_card_visibility_tiny.svg?component';

import language from './icons/language.svg?component';
import library from './icons/library.svg?component';
import library_search from './icons/library_search.svg?component';
import link from './icons/link.svg?component';
import list from './icons/list.svg?component';
import loader from './icons/loader.svg?component';
import lock_open from './icons/lock_open.svg';
import locked from './icons/locked.svg?component';

import menu_open from './icons/menu_open.svg?component';
import more from './icons/more.svg?component';
import more_time from './icons/more_time.svg?component';
import move_item from './icons/move_item.svg?component';
import move_to_folder from './icons/move_to_folder.svg?component';

import note from './icons/note.svg?component';
import note_add from './icons/note_add.svg?component';

import objects from './icons/objects.svg?component';
import open_left_panel from './icons/open_left_panel.svg?component';
import open_new from './icons/open_new.svg?component';

import pause_fill from './icons/pause_fill.svg?component';
import pause_outline from './icons/pause_outline.svg?component';
import person from './icons/person.svg?component';
import person_add from './icons/person_add.svg?component';
import person_admin from './icons/person_admin.svg?component';
import photo_size_select_large from './icons/photo_size_select_large.svg';
import photo_size_select_small from './icons/photo_size_select_small.svg';
import play_fill from './icons/play_fill.svg?component';
import play_outline from './icons/play_outline.svg?component';
import ppt_file from './icons/ppt_file.svg?component';
import present from './icons/present.svg?component';
import preview from './icons/preview.svg?component';
import print from './icons/print.svg?component';

import qr_code from './icons/qr_code.svg?component';
import quick_reference from './icons/quick_reference_all.svg?component';

import remove from './icons/remove.svg?component';
import reply from './icons/reply.svg?component';
import retry from './icons/retry.svg?component';

import schedule from './icons/schedule.svg?component';
import science from './icons/science.svg';
import search from './icons/search.svg?component';
import settings from './icons/settings.svg?component';
import snippet_attach from './icons/snippet_attach.svg?component';
import snippet_file from './icons/snippet_file.svg?component';
import snippet_image from './icons/snippet_image.svg?component';
import snippet_link from './icons/snippet_link.svg?component';
import snippet_text from './icons/snippet_text.svg?component';
import sort from './icons/sort.svg?component';
import sort_alphabetically from './icons/sort_alphabetically.svg?component';
import sort_indicator from './icons/sort_indicator.svg?component';
import sort_manual from './icons/sort_manual.svg?component';
import sparkle from './icons/sparkle.svg?component';
import spreadsheet_file from './icons/spreadsheet_file.svg?component';
import stop_outline from './icons/stop_outline.svg?component';
import students from './icons/students.svg?component';
import stylus_note from './icons/stylus_note.svg?component';
import swap from './icons/swap.svg?component';
import sync from './icons/sync.svg?component';
import sync_disabled from './icons/sync_disabled.svg?component';
import sync_warning from './icons/sync_warning.svg?component';
import syncing from './icons/syncing.svg?component';

import teachino_t from './icons/teachino_t.svg?component';
import template from './icons/template.svg?component';
import text_field from './icons/text_field.svg?component';
import thumb_down from './icons/thumb_down.svg?component';
import thumb_up from './icons/thumb_up.svg?component';
import trash from './icons/trash.svg?component';
import tutorial from './icons/tutorial.svg?component';

import unchecked_box from './icons/unchecked_box.svg?component';
import upload from './icons/upload.svg?component';

import verified from './icons/verified.svg?component';
import video_file from './icons/video_file.svg?component';
import visibility from './icons/visibility.svg?component';
import visibility_off from './icons/visibility_off.svg?component';

import bar_chart from './icons/bar_chart.svg?component';
import correct from './icons/correct.svg?component';
import create_folder from './icons/create_folder.svg';
import image_search from './icons/image_search.svg?component';
import image_upload from './icons/image_upload.svg?component';
import incorrect from './icons/incorrect.svg?component';
import interactive_assignment from './icons/interactive_assignment.svg?component';
import keyboard from './icons/keyboard.svg?component';
import partially_correct from './icons/partially_correct.svg?component';
import save_as from './icons/save_as.svg?component';
import share from './icons/share.svg?component';
import waiting from './icons/waiting.svg?component';
import warning from './icons/warning.svg?component';
import week from './icons/week.svg?component';
import week_five_days from './icons/week_five_days.svg?component';
import week_seven_days from './icons/week_seven_days.svg?component';

export const icons = {
  account,
  add,
  audio_file,
  add_circle,
  add_document_snippet,
  add_image_snippet,
  add_link_snippet,
  add_note_snippet,
  add_photo,
  add_text_snippet,
  add_box,
  agenda,
  ai_button,
  //ai_sparkle,
  angle_down,
  angle_left,
  angle_right,
  angle_up,
  arrow_back,
  arrow_drop_down,
  arrow_forward,
  arrow_outward,
  add_emoji,
  arrow_right,
  arrow_up,
  //article,
  attach,
  back,
  bar_chart,
  //backspace,
  //bookmark,
  //bookmark_add,
  //bookmark_remove,
  calendar,
  calendar_month,
  chat_history,
  //campaign,
  //category,
  check,
  //check_box_outline_blank,
  check_circle,
  check_circle_fill,
  checked_box,
  //checklist,
  //circle_cancel_fill,
  circular_cancel,
  circular_info,
  classIcon,
  close,
  //closeNote,
  collaboration,
  content,
  copy,
  courses,
  create_folder,
  chevron_right,
  create_from_template,
  change_font_size,
  cursor,
  dashboard,
  dnd,
  //doc_file,
  dots,
  download,
  draft,
  //drag_handle,
  drag_indicator,
  doc_export,
  edit,
  editor_loading,
  editor_saved,
  editor_unsaved,
  error,
  error_circle,
  expand,
  export_icon,
  external_file,
  external_folder,
  eye,
  eye_off,
  file_add,
  filter,
  folder_open,
  fullscreen,
  format_color_text,
  format_color_reset,
  generic_file,
  go_to_end,
  goal,
  help,
  info_fill,
  info_outline,
  item_card_calendar_checked,
  item_card_calendar_month_tiny,
  item_card_calendar_plus,
  item_card_one_snippet,
  item_card_three_snippets,
  item_card_timer,
  item_card_two_snippets,
  item_card_visibility_off_tiny,
  item_card_visibility_tiny,
  language,
  library,
  library_search,
  link,
  list,
  loader,
  locked,
  lock_open,
  //local_library,
  //mark_as_unread,
  menu_open,
  more,
  more_time,
  move_item,
  move_to_folder,
  note,
  note_add,
  objects,
  open_left_panel,
  open_new,
  pause_fill,
  //pdf_file,
  person,
  person_add,
  person_admin,
  photo_size_select_small,
  photo_size_select_large,
  play_fill,
  play_outline,
  pause_outline,
  ppt_file,
  present,
  preview,
  print,
  qr_code,
  quick_reference,
  remove,
  //remove_calendar_item,
  reply,
  retry,
  schedule,
  search,
  settings,
  snippet_attach,
  snippet_file,
  snippet_image,
  snippet_link,
  snippet_text,
  sort,
  sort_alphabetically,
  sort_indicator,
  sort_manual,
  sparkle,
  spreadsheet_file,
  students,
  swap,
  sync,
  syncing,
  sync_warning,
  sync_disabled,
  stop_outline,
  science,
  stylus_note,
  teachino_t,
  template,
  text_field,
  thumb_up,
  thumb_down,
  trash,
  tutorial,
  unchecked_box,
  upload,
  verified,
  visibility,
  visibility_off,
  video_file,
  waiting,
  warning,
  week,
  week_five_days,
  week_seven_days,
  image_upload,
  image_search,
  correct,
  partially_correct,
  incorrect,
  keyboard,
  share,
  interactive_assignment,
  save_as,
};

export type IconType = keyof typeof icons;
